import { posthog, posthogEnabled } from './posthog';

/** Events that count as "first meaningful desk action" for time-to-value funnels. */
const MEANINGFUL_EVENTS = new Set([
  'assumption_changed',
  'buyer_oh_category_edited',
  'liability_row_opened',
  'scenario_compared',
  'scenario_saved',
  'scenario_frozen',
  'scenario_loaded',
  'well_detail_viewed',
  'well_search_used',
  'well_detail_section_viewed',
  'evidence_opened',
  'well_ai_assessment',
  'assistant_question_asked',
  'crm_firm_opened',
]);

const sessionFlags = {
  meaningfulFired: false,
};

/**
 * Capture a product event. Safe no-op when PostHog is not configured.
 * Auto-emits `first_meaningful_action` once per browser session for funnel step 3.
 */
export function track(event, props = {}) {
  if (!posthogEnabled) return;
  try {
    posthog.capture(event, props);
    if (MEANINGFUL_EVENTS.has(event) && !sessionFlags.meaningfulFired) {
      sessionFlags.meaningfulFired = true;
      posthog.capture('first_meaningful_action', {
        source_event: event,
        ...props,
      });
    }
  } catch {
    /* swallow */
  }
}

export function trackException(error, props = {}) {
  if (!posthogEnabled) return;
  try {
    posthog.captureException(error, props);
  } catch {
    /* swallow */
  }
}

/** Debounced assumption / OH edits (slider drag). */
export function createDebouncedTracker(eventName, waitMs = 400) {
  let timer = null;
  let lastProps = null;
  return (props) => {
    lastProps = props;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (lastProps) track(eventName, lastProps);
    }, waitMs);
  };
}

/** Reset meaningful-action latch (logout). */
export function resetMeaningfulActionLatch() {
  sessionFlags.meaningfulFired = false;
}
